import { render, staticRenderFns } from "./InvestigatorList.vue?vue&type=template&id=39556ba3&"
import script from "./InvestigatorList.vue?vue&type=script&lang=js&"
export * from "./InvestigatorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports